<template>
  <transition>
    <LoadingWidget v-if="loading" />

    <section v-else-if="items.length">
      <v-container class="mt-12 pr-0 pr-sm-3 overflow-hidden container-large">
        <TitleWidget>{{ title }}</TitleWidget>

        <CarouselWidget
          class="mt-10 mt-md-12"
          :items="items"
          v-bind="carouselSettings"
          :center="center"
          :gap="gap"
          dots
        >
          <template #item="{ item }">
            <GalleryCard v-bind="item" />
          </template>
        </CarouselWidget>

        <ButtonWidget
          v-if="totalItems > carouselSettings.itemsToShow[breakpointName]"
          class="mt-10 mt-md-13 mt-lg-16"
          align="center"
          :to="path"
        >
          Ver Mais
        </ButtonWidget>
      </v-container>
    </section>
  </transition>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import GalleryCard from "../cards/GalleryCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "galleries",
  path: "/galerias-de-fotos",
};

const _pagination = {
  itemsPerPage: 3,
  returnTotalItems: 1,
};

const _carouselSettings = {
  itemsToShow: {
    xs: 1.2,
    sm: 2,
    md: 3,
    lg: 3,
    xl: 3,
  },
};

const _data = {
  loading: true,
  title: "Galerias",
  path: _config.path,
  totalItems: 0,
  carouselSettings: _carouselSettings,
};

export default {
  props: {
    courseId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, img, title, subtitle }) => ({
          img,
          title,
          subtitle,
          to: `${_config.path}/${formatToURL(title)}-${id}`,
        })
      );
    },
    breakpointName() {
      return this.$vuetify.breakpoint.name;
    },
    gap() {
      switch (this.breakpointName) {
        case "xs":
        case "sm":
          return 12;
        default:
          return 30;
      }
    },
    center() {
      switch (this.breakpointName) {
        case "xs":
          return true;
        default:
          return false;
      }
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        ..._pagination,
      };

      if (this.courseId) {
        params.courseId = this.courseId;
      }

      this.$rest(_config.mod)
        .get({
          params,
          save: (state, data) => {
            if (params.returnTotalItems) {
              state.list = data.list;
              this.totalItems = data.totalItems;
            } else {
              state.list = data;
            }
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  created() {
    this.getList();
    console.log(this.courseId);
  },
  components: {
    LoadingWidget,
    TitleWidget,
    CarouselWidget,
    GalleryCard,
    ButtonWidget,
  },
};
</script>
